<template>
  <div class="answerList">
    <el-form-item class="input-ground" :label="NumberText" :error="errorTitle">
      <el-input
        v-model.trim="answerTitle"
        class="addInputLongItem"
        :placeholder="$t('answerList.请输入题目标题')"
        show-word-limit
        maxlength="255"
        type="textarea"
        :autosize="true"
        resize="none"
        @blur="valueChange"
      ></el-input>
      <el-select
        :placeholder="$t('answerList.请选择')"
        class="addChooseItem"
        v-model="choose"
        @change="chageOptions"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="$t(`answerList.${item.label}`)"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        :placeholder="$t('answerList.请选择')"
        class="addChooseLevel"
        v-model="level"
        v-if="choose == 5"
        @change="changLevel"
      >
        <el-option
          v-for="item in levelOptions"
          :key="item.value"
          :label="$t(`answerList.${item.label}`)"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        :placeholder="$t('answerList.请选择')"
        class="addChooseType"
        :popper-append-to-body="false"
        :class="{
          addChooseOption: optionType == 0,
          addChooseStar: optionType == 1,
          addChooseHeart: optionType == 2,
          addChooseParise: optionType == 3,
          addChooseRow: optionType == 4
        }"
        v-model="optionType"
        v-if="choose == 5"
        @change="scaleTypeChange"
      >
        <el-option
          v-for="item in typeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
          <span><img :src="item.img" width="16px" height="16px" /></span>
        </el-option>
      </el-select>
      <el-checkbox v-model="forceQ" style="margin-left: 10px" @change="forceChange">{{
        $t('answerList.必填')
      }}</el-checkbox>
    </el-form-item>
    <div v-if="choose == 5 && optionType == 0">
      <el-form-item v-for="(lev, index) of levelItems" :key="index" class="level-item">
        <div class="option-choose">
          <label>选项</label>
          <el-input
            :placeholder="$t('answerList.请输入')"
            show-word-limit
            maxlength="8"
            v-model.trim="lev.item"
            class="option-choose-text"
            @blur="handleLevel(index)"
          ></el-input>
          <label>分数</label>
          <el-input
            :placeholder="$t('answerList.请输入')"
            class="option-choose-num"
            maxlength="3"
            @input="handleNumber(index)"
            @blur="levelSure(lev)"
            v-model.trim="lev.score"
          ></el-input>
        </div>
      </el-form-item>
    </div>
    <div v-if="choose == 5 && optionType != 0" class="option-choose-content">
      <div class="option-choose option-type">
        <el-input
          :placeholder="$t('answerList.请输入')"
          show-word-limit
          maxlength="8"
          v-model.trim="levelTo"
          class="type-text"
          @blur="levelToBlur"
        ></el-input>
        <el-input
          :placeholder="$t('answerList.请输入')"
          show-word-limit
          maxlength="8"
          v-model.trim="levelEnd"
          class="type-text"
          @blur="levelEndBlur"
        ></el-input>
      </div>
      <div class="level-content">
        <div v-for="(lev, index) of levelItems" :key="index" class="level-content-item">
          <img
            :src="require('@/svg/star-question.svg')"
            width="16px"
            height="16px"
            v-if="optionType == 1"
          />
          <img
            :src="require('@/svg/heart-question.svg')"
            width="16px"
            height="16px"
            v-if="optionType == 2"
          />
          <img
            :src="require('@/svg/prise-question.svg')"
            width="16px"
            height="16px"
            v-if="optionType == 3"
          />
          <span
            class="level-content-img"
            v-if="optionType == 4"
            :class="{
              'level-content-end': index + 1 === levelItems.length,
              'level-content-start': index === 0
            }"
            >{{ index + 1 }}</span
          >
          <el-input
            class="level-content-input"
            maxlength="3"
            v-model.trim="lev.score"
            v-if="lev.showInput"
            @input="handleNumber(index)"
            @blur="levelSure(lev)"
          ></el-input>
          <span class="level-content-score" @click="levelInput(lev)" v-else>{{ lev.score }}</span>
        </div>
      </div>
    </div>
    <draggable
      v-model="serialItem"
      :sort="draggableSort"
      draggable=".moreAnswerItem"
      @start="startDrag"
      ghost-class="ghost"
      @end="removeMoves"
      v-if="choose == 1 || choose == 0"
      >
        <el-form-item
          v-for="(item, index) of serialItem"
          :key="index"
          class="moreAnswerItem answer-input"
          @mouseenter="hovers(index)"
          @mouseleave="removeHove()"
        >
          <div class="item-options">
            <i class="icon-dot"></i>
            <a
              :title="$t('answerList.删除')"
              href="javascript:;"
              class="icon icon-clear addRadioRemove"
              v-if="isShowDelChoose"
              @click="removeMoreanswer(index)"
            ></a>
          </div>
          <label class="num-label">{{ item.number }}</label>
          <el-input
            show-word-limit
            maxlength="150"
            v-model.trim="item.item"
            :placeholder="$t('answerList.请输入选项')"
            @blur="chooseChange(index)"
          />
          <div v-if="item.completion" class="requiredTips fontColor">
            <span v-if="item.required"
              ><span style="color: #ea494b">*</span>{{ $t('answerList.必填') }}</span
            >
            <span v-else>{{ $t('answerList.选填') }}</span>
          </div>
          <el-checkbox v-model="item.completion" @change="chooseChange(index)">{{
            $t('answerList.添加填空')
          }}</el-checkbox>
          <el-checkbox
            v-model="item.required"
            v-if="item.completion"
            @change="chooseChange(index)"
            >{{ $t('answerList.必填') }}</el-checkbox
          >
          <label class="error-select">{{ item.error }}</label>
        </el-form-item>
    </draggable>
    <div class="m-t-8 add-choose" v-if="(choose == 1 || choose == 0) && serialItem.length < 20">
      <a type="button" class="link-blue more-blue" @click="addMoreList" href="javascript:;">
        <i class="icon-add"></i>{{ $t('answerList.添加选项') }}
      </a>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import drag from '@/components/toolList/answer/drag';

export default {
  components: {
    draggable
  },
  mixins: [drag],
  props: {
    number: {
      type: Number,
      default: 1
    },
    chooseOptions: {
      type: Number,
      default: 0
    },
    serial: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    scaleType: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 1
    },
    edit: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [
        {
          label: '单选题',
          value: 0
        },
        {
          label: '多选题',
          value: 1
        },
        {
          label: '问答题',
          value: 2
        },
        {
          label: '量表题',
          value: 5
        }
      ],
      levelOptions: [
        {
          label: '2级量表题',
          value: 1
        },
        {
          label: '3级量表题',
          value: 2
        },
        {
          label: '4级量表题',
          value: 3
        },
        {
          label: '5级量表题',
          value: 4
        },
        {
          label: '6级量表题',
          value: 5
        },
        {
          label: '7级量表题',
          value: 6
        },
        {
          label: '8级量表题',
          value: 7
        },
        {
          label: '9级量表题',
          value: 8
        },
        {
          label: '10级量表题',
          value: 9
        },
        {
          label: '11级量表题',
          value: 10
        }
      ],
      typeOptions: [
        {
          label: 'O',
          value: 0,
          img: require('@/svg/option.svg')
        },
        {
          label: '1',
          value: 1,
          img: require('@/svg/star-question.svg')
        },
        {
          label: '2',
          value: 2,
          img: require('@/svg/heart-question.svg')
        },
        {
          label: '3',
          value: 3,
          img: require('@/svg/prise-question.svg')
        },
        {
          label: '4',
          value: 4,
          img: require('@/svg/row-question.svg')
        }
      ],
      showAddSerial: true,
      draggableSort: false, //是否允许移动
      isShowDelChoose: false,
      choose: 0,
      level: 1,
      optionType: 0,
      showSelect: true,
      answerTitle: '',
      serialItem: [
        {
          number: 'A',
          item: '',
          error: '',
          completion: false,
          required: false
        },
        {
          number: 'B',
          item: '',
          error: '',
          completion: false,
          required: false
        }
      ],
      errorTitle: '',
      levelItems: [
        {
          item: this.$t('answerList.很不满意'),
          error: '',
          score: 1,
          showInput: false,
          number: 'A'
        },
        {
          item: this.$t('answerList.很满意'),
          error: '',
          score: 2,
          showInput: false,
          number: 'B'
        }
      ],
      levelTo: this.$t('answerList.很不满意'),
      levelEnd: this.$t('answerList.很满意'),
      forceQ: false
    };
  },
  computed: {
    NumberText() {
      return this.$t('answerList.第') + this.number + this.$t('answerList.题');
    }
  },
  created() {},
  watch: {
    chooseOptions: {
      immediate: true,
      handler(value) {
        this.choose = value;
      }
    },
    serial: {
      immediate: true,
      handler(value) {
        console.log(value, '添加');
        console.log(this.edit, 'this.edit');
        console.log(this.scaleType, 'this.scaleType');
        //if(this.edit){
        this.serialItem = value;
        this.levelItems = value;
        this.level = value.length - 1;
        this.optionType = this.scaleType;
        let len = value.length;
        if (this.scaleType > 0) {
          this.levelTo = value[0].item;
          this.levelEnd = value[len - 1].item;
        }
        // }else{
        //   this.serialItem = value;
        // }
        this.isShowDelChoose = value.length > 2 ? true : false;
      }
    },
    title: {
      immediate: true,
      handler(value) {
        this.answerTitle = value;
      }
    },
    force: {
      immediate: true,
      handler(value) {
        this.forceQ = value;
      }
    }
    // answerTitle: {
    //   immediate: true,
    //   handler(value) {
    //     let options = {
    //       id: this.number,
    //       title: value,
    //     };
    //     console.log(options, "题干");
    //     this.$emit("titleChage", options);
    //   },
    // },
  },
  methods: {
    handleNumber(index) {
      /* eslint-disable no-useless-escape */
      this.levelItems[index].score = this.levelItems[index].score.replace(/[^\d]/g, '');

      if (this.levelItems[index].score === '') {
        this.levelItems[index].score = 0;
      }
      this.levelItems[index].score = parseInt(this.levelItems[index].score);

      this.$forceUpdate();
    },
    levelInput(lev) {
      console.log(lev, '点击显示');
      lev.showInput = true;
      this.$forceUpdate();
    },
    levelSure(lev) {
      lev.showInput = false;
      console.log(lev, 'lev...');
      if (lev.score == '') {
        lev.score = 0;
      }
      this.$forceUpdate();
    },
    changLevel() {
      let len = this.level - this.levelItems.length + 1;
      if (len > 0) {
        this.addLevel(len);
      } else {
        this.removeLevel(len);
      }
      this.levelItems.forEach((item, index) => {
        if (index !== 0) {
          item.item = index + 1;
        }
        if (index === this.levelItems.length - 1) {
          item.item = this.$t('answerList.很满意');
        }
      });
      let options = {
        id: this.number,
        levelItems: this.levelItems
      };
      this.$emit('updateSerial', options);
      console.log(this.levelItems, 'this.levelItems');
    },
    scaleTypeChange() {
      let options = {
        id: this.number,
        levelItems: this.levelItems
      };
      this.$emit('updateSerial', options);
      this.$emit('update:scaleType', this.optionType);
    },
    addLevel(len) {
      let item = {
        item: '',
        error: '',
        score: '',
        showInput: false
      };
      if (len > 0) {
        item.score = this.levelItems.length + 1;
        item.item = this.levelItems.length + 1;
        item.number = String.fromCharCode(this.levelItems.length + 65);
        this.levelItems.push(item);
        this.levelItems[this.levelItems.length - 1].item = this.$t('answerList.很满意');
        len--;
        this.addLevel(len);
      }
    },
    removeLevel(len) {
      if (len < 0) {
        this.levelItems.pop();
        len++;
        this.removeLevel(len);
      }
    },
    valueChange() {
      let message = this.$t('answerList.请输入题干');
      if (this.answerTitle === '') {
        this.errorTitle = message;
      } else {
        this.errorTitle = '';
      }
      let options = {
        id: this.number,
        title: this.answerTitle
      };
      console.log(options, '题干');
      this.$emit('titleChage', options);
    },
    forceChange() {
      let options = {
        id: this.number,
        force: this.forceQ
      };
      console.log(options, '强制必答');
      this.$emit('forceChange', options);
    },
    chooseChange(index) {
      this.serialItem.forEach((item, d) => {
        if (d === index && item.item === '') {
          item.error = this.$t('answerList.请输入选项');
        } else if (item.error !== '' && item.item !== '') {
          item.error = '';
        }
      });
      let options = {
        id: this.number,
        levelItems: this.serialItem
      };
      this.$emit('updateSerial', options);
      // this.$forceUpdate();
      console.log(this.serialItem, 'this.serialItem');
    },
    handleLevel(index) {
      this.levelItems.forEach((item, d) => {
        if (d === index && item.item === '') {
          item.error = this.$t('answerList.请输入选项');
        } else if (item.error !== '' && item.item !== '') {
          item.error = '';
        }
      });
      let options = {
        id: this.number,
        levelItems: this.levelItems
      };
      this.$emit('updateSerial', options);
      console.log(this.levelItems, 'this.levelItems');
    },
    addMoreList() {
      let numberChar = String.fromCharCode(this.serialItem.length + 65);
      this.serialItem.push({
        item: '',
        number: numberChar,
        completion: false,
        required: false
      });
      this.$emit('update:serial', this.serialItem);
    },
    removeMoreanswer(index) {
      this.serialItem.splice(index, 1);
      let moreItem = [];
      this.serialItem.forEach((element, i) => {
        element.number = String.fromCharCode(i + 65);
        moreItem.push(element);
      });
      this.serialItem = moreItem;
    },

    chageOptions() {
      let optionsChoose = {
        id: this.number,
        choose: this.choose
      };
      this.isShowDelChoose = false;
      console.log(optionsChoose, 'optionsChoose');
      this.$emit('changeOptions', optionsChoose);
    },
    addMove() {
      this.draggableSort = true;
      console.log('移动');
    },
    removeHove() {
      console.log('结束');
    },
    levelToBlur() {
      this.levelItems[0].item = this.levelTo;
      let options = {
        id: this.number,
        levelItems: this.levelItems
      };
      this.$emit('updateSerial', options);
      console.log(this.levelItems, 'levelItems levelBlur');
    },
    levelEndBlur() {
      let levLen = this.levelItems.length - 1;
      this.levelItems[levLen].item = this.levelEnd;
      let options = {
        id: this.number,
        levelItems: this.levelItems
      };
      this.$emit('updateSerial', options);
      console.log(this.levelItems, 'levelItems levelBlur');
    }
  }
};
</script>
<style scoped lang="scss">
.answerList {
  border-radius: 8px;
  background-color: rgba(92, 97, 124, 0.3);
  padding-top: 30px;
  padding-bottom: 22px;
}
[data-theme='Orange'] .answerList {
  background-color: rgba(245, 245, 245, 1);
}
::v-deep .el-textarea__inner {
  background: $back-answer-color;
  color: $white-color;
  border-color: #525366;
}
::v-deep .el-checkbox__inner {
  background: $back-answer-color;
  border: 1px solid $gray6-color;
}
::v-deep .el-checkbox {
  margin-right: 9px;
}
::v-deep .el-textarea .el-input__count {
  bottom: 6px;
}

.link-blue {
  color: $white-color;
  text-decoration: none;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  padding: 0 15px;
  border-radius: 8px;
  margin-right: 15px;
  font-size: 12px;
}
.more-blue {
  display: flex;
  align-items: center;
}
.addInputLongItem {
  width: 360px;
  margin-right: 7px;
  margin-left: 7px;
  ::v-deep .el-textarea__inner {
    padding: 9px 20px 9px 15px;
  }
}
.addRadioInput {
  float: left;
  width: 86%;
  margin-left: -15px;
}
.addCheckedInput {
  float: left;
  width: 86%;
  margin-left: 15px;
}
.addRadio {
  float: left;
  width: 38px;
  height: 36px;
  border: 1px solid $grey3-color;
}

::v-deep .el-radio__input {
  visibility: hidden;
}

::v-deep .el-checkbox__label {
  padding-left: 2px;
  color: $white-color;
}
::v-deep .el-radio__input.is-checked + .el-radio__label,
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: $white-color;
}

::v-deep .el-radio-group {
  width: 100%;
}
.icon {
  background-repeat: no-repeat;
  margin-left: 10px;
  color: $white-color;
  cursor: pointer;
}
.icon-clear {
  background: url(../../../svg/icon-del.svg);
  width: 11px;
  height: 11px;
  &:hover,
  &:active {
    background: url(../../../svg/icon-del-red.svg);
  }
}
.icon-move-up {
  background: url(../../../svg/icon/icon-move-down.svg);
}
.icon-move-down {
  background: url(../../../svg/icon/icon-move-up.svg);
}
.numberChar {
  display: inline-block;
  width: 23px;
  height: 23px;
  color: $white-color;
}
.ticketsList {
  width: 93%;
}
.icon-move {
  background: url(../../../svg/drag.svg);
  width: 9px;
  height: 14px;
}
.addChooseItem {
  width: 100px;
  ::v-deep .el-input__inner {
    font-size: 12px;
  }
}
.addChooseLevel {
  width: 80px;
  margin: 0 7px;
  ::v-deep .el-input__inner {
    font-size: 12px;
  }
}
.addChooseType {
  width: 55px;
}
.addChooseOption {
  ::v-deep .el-input__inner {
    background: url('../../../svg/option.svg') no-repeat;
    background-position: 10px;
    font-size: 0;
    background-size: 16px;
    border-color: #525366;
  }
}
.addChooseStar {
  ::v-deep .el-input__inner {
    background: url('../../../svg/star-question.svg') no-repeat;
    background-position: 10px;
    font-size: 0;
    background-size: 16px;
    border-color: #525366;
  }
}
.addChooseHeart {
  ::v-deep .el-input__inner {
    background: url('../../../svg/heart-question.svg') no-repeat;
    background-position: 10px;
    font-size: 0;
    background-size: 16px;
    border-color: #525366;
  }
}
.addChooseParise {
  ::v-deep .el-input__inner {
    background: url('../../../svg/prise-question.svg') no-repeat;
    background-position: 10px;
    font-size: 0;
    background-size: 16px;
    border-color: #525366;
  }
}
.addChooseRow {
  ::v-deep .el-input__inner {
    background: url('../../../svg/row-question.svg') no-repeat;
    background-position: 10px;
    font-size: 0;
    background-size: 16px;
    border-color: #525366;
  }
}
.moreAnswerItem {
  margin-bottom: 10px;
  ::v-deep .el-input__inner {
    height: 32px;
  }
}
.input-ground {
  color: $white-color;
  display: flex;
  margin-bottom: 20px;
}
.input-ground ::v-deep .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.add-choose {
  color: $white-color;
  display: flex;
  text-align: left;
  margin-left: 50px;
}
.addAnswerFrom {
  .answerList {
    ::v-deep .el-form-item__content {
      display: flex;
      align-items: center;
    }
    ::v-deep .el-form-item__label {
      font-size: 14px;
    }
    ::v-deep .el-checkbox__label {
      font-size: 12px;
    }
  }
}
.item-tips {
  display: flex;
  align-items: center;
  height: 30px;
  background: #3d4166;
  border-radius: 4px;
  justify-content: space-between;
  padding: 0 70px 0 20px;
  color: #acb2bf;
}
.item-tips-level {
  padding-right: 30px;
}
.moreAnswerItem {
  cursor: move;
  ::v-deep .el-input {
    font-size: 12px;
    width: 360px;
    margin-right: 7px;
  }
}
.item-options {
  display: flex;
  margin-right: 7px;
  width: 43px;
  justify-content: flex-end;
}
.num-label {
  color: #fff;
  margin-right: 7px;
  width: 10px;
}
[data-theme='Orange'] .num-label {
  color: #3e3f41;
}
.option-choose {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;
  padding-left: 36px;
  &-content {
    border: 1px dashed #7d7f8c;
    width: 580px;
    height: 106px;
    margin-left: 65px;
    padding-top: 21px;
    padding-left: 18px;
    padding-right: 19px;
    padding-bottom: 5px;
    margin-bottom: 12px;
  }
}
[data-theme='Orange'] .option-choose {
  color: #3e3f41;
  &-content {
    color: #3e3f41;
    border: 1px dashed #e0e1e6;
  }
}
.type-text {
  width: 148px;
  ::v-deep .el-input__inner {
    height: 32px;
  }
}
.option-type {
  justify-content: space-between;
  padding: 0;
}
.level-content {
  display: flex;
  justify-content: space-between;
  height: 50px;
  margin-top: 15px;
  &-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 40px;
    flex: 1;
  }
  &-score {
    color: $white-color;
    margin-top: 20px;
    cursor: pointer;
    width: 40px;
    display: inline-block;
    height: 20px;
  }
  &-input {
    margin-top: 10px;
    width: 40px;
    ::v-deep .el-input__inner {
      padding: 5px;
      height: 20px;
      line-height: 20px;
      border-color: #525366;
    }
  }
  &-img {
    width: 90%;
    display: inline-block;
    text-align: center;
    height: 20px;
    line-height: 20px;
    color: #aab0bd;
    border: 1px solid #aab0bd;
  }
  &-start {
    border-radius: 3px 0px 0px 3px;
  }
  &-end {
    border-radius: 0 3px 3px 0;
  }
}
[data-theme='Orange'] .level-content {
  &-score {
    color: #3e3f41;
  }
}
.requiredTips {
  line-height: 30px;
  width: 80px;
  border-bottom: 1px solid #060608;
  margin-left: 6px;
  font-size: 12px;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.icon-dot {
  background-image: url('../../../svg/icon-dot.svg');
  width: 10px;
  height: 10px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.ghost {
  background: rgba(57, 134, 238, 0.4);
  .icon-dot {
    background-image: url('../../../svg/icon-dot-blue.svg');
  }
}
.icon-add {
  background-image: url('../../../svg/icon-add-question.svg');
  width: 12px;
  height: 12px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-right: 5px;
}
[data-theme='Orange'] .icon-add {
  background-image: url('../../../svg/icon-add-orange.svg');
}
.option-choose-text {
  width: 360px;
  margin-right: 14px;
  ::v-deep .el-input__inner {
    height: 32px;
    font-size: 12px;
    margin-left: 7px;
  }
}
.option-choose-num {
  width: 156px;
  margin-left: 7px;
  ::v-deep .el-input__inner {
    height: 32px;
    font-size: 12px;
  }
}
.error-select {
  color: #f56c6c;
  font-size: 12px;
}
.level-item {
  margin-bottom: 10px;
}
.moreAnswerItem ::v-deep .el-input__inner{
  padding-right: 57px;
}
.option-choose-text ::v-deep .el-input__inner{
  padding-right: 57px;
}
.option-choose-content ::v-deep .el-input__inner{
  padding-right: 37px;
}
</style>
<style>
[data-theme='Orange'] .el-checkbox__label {
  color: #3e3f41 !important;
}
</style>
